import { Component } from '@angular/core';

@Component({
  selector: 'lib-vmailbox-widget-add',
  imports: [],
  templateUrl: './vmailbox-widget-add.component.html',
  styleUrl: './vmailbox-widget-add.component.scss',
})
export class VMailboxWidgetAddComponent {

}
